import { useStaticQuery, graphql } from "gatsby";

const useRefDesignTableKeys = () => {
    const { wp } = useStaticQuery(graphql`
        query RefDesignTableKeys {
            wp {
                optionsPage {
                    globalOptions {
                        tableKeys {
                            attributeIdentifier
                            icon
                            label
                            image {
                                altText
                                title
                                sourceUrl
                                localFile {
                                    childImageSharp {
                                        gatsbyImageData(width: 60)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const refDesignKeys = wp?.optionsPage?.globalOptions?.tableKeys ?? [];

    return {
        refDesignKeys,
    };
};

export default useRefDesignTableKeys;
